<div class="planned-item d-flex align-items-center" [class.past-due-item]="isPastDue()">

  <div class="color-gray-300 planned-item-icon me-2">
    <app-gray-checkbox
      [value]="!!item.completedAt"
      (click)="config.canEdit && toggled.emit(item)"></app-gray-checkbox>
  </div>

  <!-- Text and lesson topic items -->
  <div class="w-100" *ngIf="!isVideo()">
    <div class="planned-item-header align-items-end d-flex fw-400 fs-xsmall">
      <div>{{item?.exam?.examKey|uppercase}} {{item?.lesson?.name}}</div>

      <div class="after-border" *ngIf="config.showAssignedTime && item.assignedDateTime && !item.completedAt">
        <span> | {{item.assignedDateTime | datetime: 'dddd | HH:mm'}}</span>
        <span *ngIf="isPastDue()"> | {{item.assignedDateTime | pastTime}}</span>
      </div>

      <div class="after-border ms-auto color-gray-950" *ngIf="config.canEdit"
           [ngbPopover]="itemMenu" [autoClose]="'outside'" #popover="ngbPopover"
           popoverClass="hour-select-popover" placement="left-top" (click)="menuOpened.emit(item)">
        <span class="fs-large clickable">...</span>
      </div>
    </div>

    <div class="planned-item-body fw-400 fs-normal">
      <span *ngIf="item.repeatParentId && !isText()"
            [ngbTooltip]="'planner.repeat_lesson_label'|translate" container="body">(T) </span>{{title()}}
    </div>
  </div>

  <!-- Video items are rendered by the app that owns the player -->
  <div class="w-100" *ngIf="isVideo()">
    <div class="planned-item-body fw-400 fs-normal d-flex align-items-center">
      <div class="col-11">
        <ng-container *ngIf="videoTemplate; else plainVideo"
                      [ngTemplateOutlet]="videoTemplate"
                      [ngTemplateOutletContext]="{$implicit: item}"></ng-container>

        <ng-template #plainVideo>
          <p class="mb-0">{{item.video?.title}}</p>
        </ng-template>
      </div>

      <div class="col-1 d-flex" *ngIf="config.canEdit">
        <div class="after-border ms-auto color-gray-950"
             [ngbPopover]="itemMenu" [autoClose]="'outside'" #videoPopover="ngbPopover"
             popoverClass="hour-select-popover" placement="left-top" (click)="menuOpened.emit(item)">
          <span class="fs-large clickable">...</span>
        </div>
      </div>
    </div>
  </div>

  <ng-template #itemMenu>
    <!-- The host may bring its own menu; the default below covers the shared actions. -->
    <ng-container *ngIf="menuTemplate; else defaultMenu"
                  [ngTemplateOutlet]="menuTemplate"
                  [ngTemplateOutletContext]="{$implicit: item}"></ng-container>

    <ng-template #defaultMenu>
    <div class="d-flex flex-column gap-3">
      <div>
        <h6 class="color-gray-400 fw-400 fs-small" *ngIf="item?.exam?.examKey || item?.lesson?.name">
          {{item?.exam?.examKey|uppercase}} {{item?.lesson?.name}}
        </h6>
        <p class="color-gray-50 fw-400 fs-large mb-0">{{isVideo() ? item.video?.title : title()}}</p>
      </div>

      <hr class="m-0 color-white"/>

      <div>
        <a class="color-gray-50 clickable" (click)="transferRequested.emit(item)">
          {{'planner.move_another_week'|translate}}
        </a>
      </div>

      <hr class="m-0 color-white"/>

      <div class="d-flex justify-content-between align-items-end gap-3">
        <a class="color-gray-50 clickable" (click)="duplicateRequested.emit(item)">
          {{'planner.duplicate'|translate}}
        </a>

        <a class="text-danger d-flex align-items-center clickable justify-content-end"
           (click)="removeRequested.emit(item)">
          <gray-icon icon="trash" style="width: 20px; height: 20px"></gray-icon>
          {{'buttons.remove'|translate}}
        </a>
      </div>
    </div>
    </ng-template>
  </ng-template>

</div>
